import React from 'react';
import {pageWithPrismic} from "../website-gridhaus/pageWithPrismic";
import {RichText} from "prismic-reactjs";
import CallToActionSection from "../sections/CallToActionSection";
import {routes, site} from "../config";
import {Link} from "react-router-dom";
import DownArrow from "../parts/DownArrow";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaTitles} from "../website-gridhaus/meta";


class WorkPage extends React.Component {
  constructor(props) {
    super(props);
    this.works = this.works.bind(this);
  }

  componentDidMount() {
    window.analytics.page("Work");
  }

  works() {
    if (this.props.works) {
      return (
        <section className={'works'}>
          <ul className={'works'}>
            {this.props.works.map((work) => {
              const data = work.data;

              return (
                <li key={work.uid}>
                  <Link to={routes.work + '/' + work.uid}>
                    <div key={work.uid} className={'work'}>
                      <div className={'background-image'}
                           style={{backgroundImage: `url(${data.hero_image.url})`}}/>
                      <div className={'container'}>
                        <h2 className={'name'}>{data.name}</h2>
                        <div className={'slogan'}>{data.slogan}</div>
                      </div>
                    </div>
                  </Link>
                </li>
              )
            })}
          </ul>
        </section>
      )
    }

    return null;
  }

  render() {
    window.prerenderReady = false;
    if (this.props.page && this.props.page.doc) {
      window.prerenderReady = true;
      const data = this.props.page.doc.data;
      return (
        <div className={'page-work'}>
          <Helmet>
            <title>{site.titlePrefix + 'Work'}</title>
            {metaTitles(site.titlePrefix + 'Work')}
            {metaDescriptions(RichText.asText(data.hero_message))}
          </Helmet>
          <section className={'hero'} id={'hero'}>
            <div className={'container'}>
              <h1 className={'title'}>{data.hero_title}</h1>
              <div className={'brief'}>{RichText.render(data.hero_message)}</div>
            </div>
            <DownArrow scrollPastId={'hero'}/>
          </section>
          <div className={'content'}>
            {this.works()}
            <CallToActionSection/>
          </div>
        </div>
      )
    }

    return null;
  }
}


export default pageWithPrismic(WorkPage, 'work_page',
  (state) => {
    return {
      works: state.works.items
    }
  },
);


// WEBPACK FOOTER //
// ./src/pages/WorkPage.js